import { bearerHeader } from "@/common/authorization"
import { type ClientDefaults, fetchClient } from "@/common/fetchclient"

// returns client instance preconfigured for requests to our netlify functions
// example of use:
//   client = netlifyFunctionClient(opts);
//   const response = await client.get('foo'); // call 'foo' function
export const netlifyFunctionClient = function (options: Partial<ClientDefaults> = {}) {
  const site = window.location.origin
  const defaults: ClientDefaults = {
    baseURL: site + "/.netlify/functions/",
    headers: {
      "X-Requested-With": "XmlHttpRequest", // CSRF prevention
    },
    // Authorization is resolved per request so clients constructed before
    // login still send a bearer token once the user signs in.
    getHeaders: async () => ({ Authorization: await bearerHeader() }),
  }
  const config = Object.assign({}, defaults, options)
  return fetchClient(config)
}
